const AVATAR_SIZE = 28;
const EXPANDED_GAP = 5;
const EXPANDED_STEP = AVATAR_SIZE + EXPANDED_GAP;
const REGULAR_GAP = 10;
const COMPACT_GAP = 8;
const REGULAR_PADDING_X = 20;
const COMPACT_PADDING_X = 16;

type SpaceSwitcherDensity = "regular" | "compact";

type SpaceSwitcherLayoutProject = {
  active?: boolean;
  spaces: readonly unknown[];
};

function getSpaceSwitcherMaxWidth<Project extends SpaceSwitcherLayoutProject>(
  projects: readonly Project[],
  density: SpaceSwitcherDensity = "regular",
  options: { projectOnly?: boolean } = {},
): number {
  const activeProject = projects.find((project) => project.active);
  const stackItemCount = projects.length + 1;
  const stackWidth = AVATAR_SIZE + (stackItemCount - 1) * EXPANDED_STEP;
  const spaceCount = options.projectOnly
    ? 0
    : (activeProject?.spaces.length ?? 0);
  const hasDivider = spaceCount > 0;
  const hasAddSpace = !options.projectOnly && Boolean(activeProject);
  const childCount =
    1 + (hasDivider ? 1 : 0) + spaceCount + (hasAddSpace ? 1 : 0);
  const childWidths =
    stackWidth +
    (hasDivider ? 1 : 0) +
    spaceCount * AVATAR_SIZE +
    (hasAddSpace ? AVATAR_SIZE : 0);
  const gap = density === "compact" ? COMPACT_GAP : REGULAR_GAP;
  const paddingX =
    density === "compact" ? COMPACT_PADDING_X : REGULAR_PADDING_X;

  return paddingX + childWidths + Math.max(0, childCount - 1) * gap;
}

export { getSpaceSwitcherMaxWidth };
